<template>
    <div class="around_list">
        <div class="around_item">
            <div class="item_text_box">
                <div class="item_title">Discover and showcase real-time and accurate citations</div>
                <div class="item_desc">The plug-in automatically identifies and displays up-to-date citation data for
                    academic articles that is helping researchers and institutions highlight their scholarly footprint
                    with clarity and credibility.</div>
            </div>
            <div class="around_iamge">
                <img src="../../assets/images/services/plugin2.png" alt="">
            </div>
        </div>

        <!-- <div class="around_item around_reverse">
            <div class="around_iamge">
                <img src="../../assets/images/home/home_2.png" alt="">
            </div>
            <div class="item_text_box">
                <div class="item_title">Recommend contextual research</div>
                <div class="item_desc">Using intelligent matching algorithms, the plug-in recommends highly relevant
                    research articles tailored to each reader’s field of interest which is offering content that aligns
                    with their reading behavior, discipline, and topical focus.</div>
            </div>
        </div>

        <div class="around_item">
            <div class="item_text_box">
                <div class="item_title">Keep scholars informed</div>
                <div class="item_desc">By surfacing the most recent and relevant developments in a given field,
                    Contrimetric keeps scholars continuously informed and connected with the evolving research
                    landscape.</div>
            </div>
            <div class="around_iamge">
                <img src="../../assets/images/home/home_3.png" alt="">
            </div>
        </div>

        <div class="around_item around_reverse">
            <div class="around_iamge">
                <img src="../../assets/images/home/home_4.png" alt="">
            </div>
            <div class="item_text_box">
                <div class="item_title">Designed for ease & access</div>
                <div class="item_desc">Free to use and simple to integrate, the plug-in fits seamlessly into websites,
                    digital libraries, repositories and journal platforms to deliver real value with zero friction.
                </div>
            </div>
        </div> -->
    </div>
</template>

<script>
export default {
    data() {
        return {

        }
    }
}
</script>

<style lang='scss'>
@import "../../assets/css/minix.scss";

.around_list {
    @include responsive-width(1200px);

    .storng_text {
        font-weight: bold;
    }

    .around_item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        line-height: 1.5;

        .item_text_box {
            flex: 0 0 48%;

            .item_title,
            .item_desc,
            .item_parts {
                font-size: 16px;
            }

            .item_title {
                font-size: 30px;
                font-weight: bold;
                line-height: 1.36;
                color: black;
            }

            .item_sub_title {
                font-size: 20px;
                font-weight: bold;
                margin-top: 6px;
            }

            .item_desc_title {
                margin-top: 6px;
                font-style: italic;
            }

            .item_desc {
                margin: 20px 0;
            }

            .item_parts {
                .item_part_point {
                    width: 5px;
                    height: 5px;
                    border-radius: 50%;
                    background-color: black;
                }

                .item_part1,
                .item_part2,
                .item_part3 {
                    display: flex;
                    align-items: baseline;
                    margin-bottom: 10px;

                    div {
                        margin-left: 14px;
                    }
                }

                .item_part1 {
                    margin-bottom: 10px;
                }

                div {
                    position: relative;

                    i {
                        background-color: #e1f8fa;
                        padding: 4px;
                        border-radius: 50%;
                        color: #1da6b8;
                    }
                }
            }
        }

        .around_iamge {
            width: 100%;
            text-align: center;
            img {
                width: 70%;
            }
        }
    }
}

@media (max-width: 768px) {
    .around_list {
        .around_item {
            flex-direction: column;

            .item_text_box {
                .item_title {
                    font-size: 24px;
                }
            }

            .around_iamge {
                text-align: center;

                img {
                    width: 70%;
                }
            }
        }

        .around_reverse {
            flex-direction: column-reverse;
        }
    }
}
</style>